import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api';
import { useTheme } from '../ThemeContext';
import { BASE_URL } from '../api';

export default function Login() {
  const { colors, common } = useTheme();
  const navigate = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [unverified, setUnverified]   = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMsg, setResendMsg]         = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setUnverified(false);
    setResendMsg('');
    try {
      const { data } = await login({ email, password });
      localStorage.setItem('token', data.token);
      navigate('/dashboard');
    } catch (err) {
      if (err.response?.data?.unverified) {
        setUnverified(true);
        setError('Please verify your email address before signing in.');
      } else {
        setError(err.response?.data?.error || 'Invalid email or password.');
      }
    }
  };

  const handleResend = async () => {
    setResendLoading(true);
    setResendMsg('');
    try {
      const res = await fetch(`${BASE_URL}/api/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setResendMsg(data.message || 'Sent.');
    } catch {
      setResendMsg('Could not resend. Please try again.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <main id="main-content" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', backgroundColor: colors.pageBg, padding: 20,
    }}>
      <div style={{
        backgroundColor: colors.cardBg, border: `1px solid ${colors.borderColor}`,
        boxShadow: '0 24px 48px rgba(0,0,0,0.2)', padding: '40px 36px',
        borderRadius: 16, width: '100%', maxWidth: 400,
      }}>
        <div style={{
          width: 44, height: 44, borderRadius: 12,
          background: `linear-gradient(135deg, ${colors.indigo}, #7c3aed)`,
          color: colors.white, fontSize: 22, fontWeight: 800,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 16, boxShadow: `0 4px 12px rgba(79,70,229,0.4)`,
        }}>S</div>

        <h1 style={{ margin: '0 0 4px 0', fontSize: 24, fontWeight: 800, color: colors.textPrimary, letterSpacing: '-0.02em' }}>
          Software Simulation Builder
        </h1>
        <p style={{ margin: '0 0 28px 0', color: colors.textSecondary, fontSize: 14 }}>
          Sign in to your account
        </p>

        {error && (
          <div role="alert" style={{ ...common.errorText, marginBottom: unverified ? 8 : 0 }}>
            {error}
          </div>
        )}

        {unverified && (
          <div style={{ marginBottom: 16 }}>
            <button
              style={{ ...common.btn, fontSize: 13, opacity: resendLoading ? 0.7 : 1 }}
              onClick={handleResend}
              disabled={resendLoading}
            >
              {resendLoading ? 'Sending...' : 'Resend verification email'}
            </button>
            {resendMsg && (
              <p style={{ marginTop: 8, color: colors.successText, fontSize: 13 }}>{resendMsg}</p>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <label htmlFor="login-email" style={common.label}>Email address</label>
          <input id="login-email" style={common.input} type="email" placeholder="you@example.com"
            value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          <label htmlFor="login-password" style={common.label}>Password</label>
          <input id="login-password" style={common.input} type="password" placeholder="••••••••"
            value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button style={{ ...common.btn, ...common.btnPrimary, width: '100%', justifyContent: 'center', padding: 11, fontSize: 15, marginTop: 4 }}
            type="submit">Sign In</button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, color: colors.textMuted, fontSize: 14 }}>
          Don't have an account?{' '}
          <a href="/register" style={{ color: colors.link, textDecoration: 'none', fontWeight: 600 }}>Register</a>
        </p>
      </div>
    </main>
  );
}
